import { Space } from "@mantine/core";
import { AppearancePreferences } from "../../Components/Preferences/AppearancePreferences";
import { NotificationsPreferences } from "../../Components/Preferences/NotificationPreferences";

const PreferencesPage = () => {

	return <>
		<NotificationsPreferences />
		<Space h="lg" />
		<AppearancePreferences />
	</>;
};

export default PreferencesPage;